"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TransportError =
/*#__PURE__*/
function (_Error) {
  _inherits(TransportError, _Error);

  function TransportError(message, code, body, status, headers) {
    var _this;

    _classCallCheck(this, TransportError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransportError).call(this, message));
    _this.code = code;
    _this.body = body;
    _this.status = status;
    _this.headers = headers;
    return _this;
  }

  return TransportError;
}(_wrapNativeSuper(Error));

exports.TransportError = TransportError;